module.exports = __webpack_public_path__ + "img/img_erweima@2x.0b504115.png";